import {getAppConfigRequestKeys} from '../../appConfig/getAppConfigRequestKeys';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {AppConfigKeyValueMapVo} from '../../common/shared/api/nicolas/vo/AppConfigKeyValueMapVo.interface';
import {AppConfigKeyVo} from '../../common/shared/api/nicolas/vo/enums/AppConfigKeyVo.enum';

/**
 * 앱 뱃지 설정 조회
 *
 * Origin: pageNicolasApi.getAppBadge
 * API: GET /api/v1/app/badge
 */
export async function getAppBadge(
  options?: FetcherOptions
): Promise<AppConfigKeyValueMapVo & ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/app/badge',
    {
      method: 'GET',
      params: {
        keys: getAppConfigRequestKeys([
          AppConfigKeyVo.GiftLastAddedDate,
          AppConfigKeyVo.NoticeLastAddedDate,
          AppConfigKeyVo.MyNewsLastAddedDate,
          AppConfigKeyVo.HelixGiftLastAddedData,
        ]),
      },
    },
    options
  );
  return response.data;
}
